import { Page } from '@optools/components/layout/page';
import { authorizedRouteLoader } from '@optools/utils/auth/authorized-route-loader';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/logger')({
  beforeLoad: authorizedRouteLoader('logger'),
  component: RouteComponent,
});

function RouteComponent() {
  return <Page title="Logger" />;
}
